import styled from 'styled-components';

interface Props {
  hasFocus: boolean;
  disabled: boolean;
}

export const Container = styled.div<Props>`
  border: 1px solid
    ${({ hasFocus, theme }) =>
      hasFocus ? theme.colors.primary : theme.colors.grey};
  border-radius: 25px;
  height: 40px;
  min-width: 300px;
  display: flex;
  align-items: center;
  transition: all 200ms;
  background-color: ${(props) =>
    props.disabled && props.theme.colors.lightGrey};

  input {
    border: transparent;
    border-radius: 25px;
    height: 100%;
    width: 100%;
    padding: 8px 12px;
    color: #1a1a1a;

    &:disabled {
      background-color: transparent;
    }
  }

  button {
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    color: ${(props) => props.theme.colors.primary};
    margin-right: 4px;
    transition: all 200ms;

    &:disabled {
      color: ${(props) => props.theme.colors.grey};
    }
  }
`;
